module.exports = __webpack_public_path__ + "img/philipp-katzenberger-iIJrUoeRoCQ-unsplash.19092694.jpg";